import { createSlice } from "@reduxjs/toolkit";
import { APIStatus } from "../../constants";
import {
	delQueTypeAndWeightage,
	getAllQueTypeAndWeightage,
	questionTypeAndWeightageCreate,
	updateQueTypeAndWeightage,
} from "./settings.service";
import { SettingsReducer } from "../../modal/settings";

const initialState: SettingsReducer = {
	createQuestionTypeAndWeightageComplete: null,
	getAllQueTypeAndWeightageComplete: null,
	updateQueTypeAndWeightageCompleted: null,
	queTypeAndWeightage: [],
	delQueTypeAndWeightageComplete: null,
	isNegativeMark: false,
};

const settingsSlice = createSlice({
	name: "settings",
	initialState,
	reducers: {
		clearGetAllQueTypeAndWeightage(state) {
			state.getAllQueTypeAndWeightageComplete = null;
		},
		clearCreateTypeAndWeightageQuestion(state) {
			state.createQuestionTypeAndWeightageComplete = null;
		},
		clearDeleteQueTypeAndWeightage(state) {
			state.delQueTypeAndWeightageComplete = null;
		},
		clearUpdateQueTypeAndWeightage(state) {
			state.updateQueTypeAndWeightageCompleted = null;
		},
		toggleNegativeMark(state, action) {
			state.isNegativeMark = action.payload ;
		},
	},
	extraReducers(builder) {
		builder.addCase(getAllQueTypeAndWeightage.fulfilled, (state, action) => {
			state.getAllQueTypeAndWeightageComplete = APIStatus.FULFILLED;
			state.queTypeAndWeightage = action.payload.data;
		});
		builder.addCase(getAllQueTypeAndWeightage.rejected, (state) => {
			state.getAllQueTypeAndWeightageComplete = APIStatus.REJECTED;
		});

		builder.addCase(questionTypeAndWeightageCreate.fulfilled, (state) => {
			state.createQuestionTypeAndWeightageComplete = APIStatus.FULFILLED;
		});
		builder.addCase(questionTypeAndWeightageCreate.rejected, (state) => {
			state.createQuestionTypeAndWeightageComplete = APIStatus.REJECTED;
		});
		builder.addCase(updateQueTypeAndWeightage.fulfilled, (state) => {
			state.updateQueTypeAndWeightageCompleted = APIStatus.FULFILLED;
		});
		builder.addCase(updateQueTypeAndWeightage.rejected, (state) => {
			state.updateQueTypeAndWeightageCompleted = APIStatus.REJECTED;
		});

		builder.addCase(delQueTypeAndWeightage.fulfilled, (state) => {
			state.delQueTypeAndWeightageComplete = APIStatus.FULFILLED;
		});
		builder.addCase(delQueTypeAndWeightage.rejected, (state) => {
			state.delQueTypeAndWeightageComplete = APIStatus.REJECTED;
		});
	},
});

export const {
	clearGetAllQueTypeAndWeightage,
	clearDeleteQueTypeAndWeightage,
	clearUpdateQueTypeAndWeightage,
	toggleNegativeMark,
	clearCreateTypeAndWeightageQuestion,
} = settingsSlice.actions;

export default settingsSlice.reducer;
